<template>
    <ns-modal v-model="dialog" :fullscreen="fullscreen" :title="txc.edit_gender" @input="closeDialog">
        <server-error v-if="!!dialogError" :error="dialogError"/>
        <v-radio-group row v-model="genderSelected">
            <v-radio value="MALE">
                <template v-slot:label>
                    {{ sharedStrings.person.male }}
                </template>
            </v-radio>
            <v-radio value="FEMALE">
                <template v-slot:label>
                    {{ sharedStrings.person.female }}
                </template>
            </v-radio>
            <v-radio value="OTHER" v-if="allowThirdGender">
                <template v-slot:label>
                    {{ sharedStrings.person.otherGender }}
                </template>
            </v-radio>
        </v-radio-group>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        @click="editGender"
                        data-test-id="personalInfo-gender-modal-save"
                    >{{sharedStrings.generic.save}}
                    </button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        block
                        outline
                        class="secondary-hit fluid"
                        @click="closeDialog"
                        data-test-id="personalInfo-gender-modal-cancel"
                    >{{sharedStrings.generic.cancel}}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>

import * as ruleSet from '../../repositories/globalRules.js';
import profileUtils from '../../repositories/profileUtils';
import {ProfileService} from '@nuskin/ns-account';
import { NsModal } from '@nuskin/design-components';
import ServerError from '../ServerError';

import { mapGetters , mapActions} from 'vuex';

export default {
    components: {
        NsModal,
        ServerError
    },
    props: {
        'fullscreen':String,
        'gender':String,
        'payTypes':Object
    },
    data() {
        return {
            ruleSet,
            genderSelected: '',
            dialogError: null,
            dialog: true
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsPersonal',
            sharedStrings: 'sharedStrings',
            allowThirdGender: 'allowThirdGender'
        })
    },
    methods:{
        ...mapActions(['updateGender']),

        closeDialog(){
            this.$emit('closeDialog');
            this.dialogError = null;
        },
        editGender() {
            let self = this;
            let personInfo = {
                gender: self.genderSelected
            };
            ProfileService.updatePerson(personInfo).then(function (response) {
                self.updateGender(self.genderSelected);
                self.closeDialog();
                profileUtils.publishAnalytics(self.$analytics.category.personal, 'gender', 'updated')
            }).catch(error => {
                self.dialogError = error;
            });
        }
    },
    created() {
        this.genderSelected = this.gender ;
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'gender_dialog', 'opened')
    },
    destroyed() {
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'gender_dialog', 'closed')
    }
}
</script>

<style scoped>
</style>